module.exports = __webpack_public_path__ + "img/Card_diamond_3.c49bdf12.svg";